import FileUpload from './FileUpload';
import './style/index.less';

export default FileUpload;
